<template>
    <div class="container mx-auto">
        <div class="p-8 md:py-20 h-full mx-auto flex flex-col md:w-1/2">
            <h1 class="my-2 mb-10 font-light">
                {{ $t("password_forgot")}}
            </h1>

            <div class="py-1">
                <input type="email"
                       v-model="email"
                       :placeholder="$t('email')" class="input w-full">
            </div>

            <div class="py-4 md:flex">
                <button class="btn btn-orange" :disabled="loading" @click="send()">
                    {{ $t('send_mail') }}
                </button>

                <button class="btn mt-2" @click="goBack()">
                    {{ $t('back') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        inject: ['alert'],

        data() {
            return {
                loading: false,
                email: null
            }
        },

        methods: {
            goBack() {
                this.$router.go(-1);
            },

            send() {
                this.loading = true;

                Zapin
                    .auth()
                    .passwordRecover(this.email)
                    .then(res => {
                        this.alert.success(res.data.message);
                    })
                    .catch(err => {
                        if(err.status === 422) {
                            return this.alert.showValidationErrors(err.data);
                        }

                        this.alert.show(this.$t('unknown_error_try_again'));
                    })
                    .finally(() => this.loading = false);
            }
        }

    }
</script>
